import * as accessors from './Accessors'
import * as Cells from './Cells'

export const searchVehicle = {
    accessors,
    Cells,
}
